import { USUARIOS, SESSAO_DURACAO_MS } from '../config/credenciais';

const TOKEN_KEY = 'sipremoAuthToken';
const MAX_TENTATIVAS = 5;
const COOLDOWN_MS = 30000;

let tentativas = 0;
let cooldownAte = 0;

async function sha256Hex(texto) {
  if (!crypto || !crypto.subtle) {
    throw new Error('Web Crypto is not available in this browser.');
  }
  const buffer = new TextEncoder().encode(texto);
  const digest = await crypto.subtle.digest('SHA-256', buffer);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

function compareConstante(a, b) {
  if (a.length !== b.length) return false;
  let diff = 0;
  for (let i = 0; i < a.length; i += 1) {
    diff |= a.charCodeAt(i) ^ b.charCodeAt(i);
  }
  return diff === 0;
}

function candidatos() {
  const lista = [...USUARIOS];
  const envUsuario = process.env.REACT_APP_LOGIN_USER;
  const envSenha = process.env.REACT_APP_LOGIN_PASSWORD;
  if (envUsuario && envSenha) {
    lista.push({ usuario: envUsuario, nome: envUsuario, hash: null, senhaAmbiente: envSenha });
  }
  return lista;
}

export async function autenticar(usuario, senha) {
  const nome = String(usuario || '').trim();
  const senhaTexto = String(senha || '');

  if (cooldownAte > Date.now()) {
    const segundos = Math.ceil((cooldownAte - Date.now()) / 1000);
    return { success: false, error: `Too many attempts. Wait ${segundos}s.` };
  }

  if (!nome || !senhaTexto) {
    return { success: false, error: 'Enter a username and password.' };
  }

  const alvo = candidatos().find(
    (u) => String(u.usuario).toLowerCase() === nome.toLowerCase()
  );

  if (!alvo) {
    return { success: false, error: 'User not registered.' };
  }

  const ok = alvo.senhaAmbiente
    ? compareConstante(senhaTexto, alvo.senhaAmbiente)
    : compareConstante(await sha256Hex(senhaTexto), alvo.hash);

  if (!ok) {
    tentativas += 1;
    if (tentativas >= MAX_TENTATIVAS) {
      cooldownAte = Date.now() + COOLDOWN_MS;
      tentativas = 0;
      return { success: false, error: 'Too many attempts. Wait 30s.' };
    }
    return { success: false, error: 'Incorrect password.' };
  }

  tentativas = 0;
  cooldownAte = 0;
  const payload = {
    usuario: alvo.usuario,
    nome: alvo.nome || alvo.usuario,
    exp: Date.now() + SESSAO_DURACAO_MS,
  };
  const token = btoa(JSON.stringify(payload));
  localStorage.setItem(TOKEN_KEY, token);
  return { success: true, ...payload };
}

export function estaAutenticado() {
  const raw = localStorage.getItem(TOKEN_KEY);
  if (!raw) return null;
  try {
    const payload = JSON.parse(atob(raw));
    if (!payload || !payload.usuario || !payload.exp || payload.exp < Date.now()) {
      localStorage.removeItem(TOKEN_KEY);
      return null;
    }
    return payload;
  } catch (err) {
    localStorage.removeItem(TOKEN_KEY);
    return null;
  }
}

export function encerrarSessao() {
  localStorage.removeItem(TOKEN_KEY);
}
